<template>
  <div>
    <div class="clientCon">
      <ButtonGroup
        class="btnCon"
        size="small"
        v-if="
          JSON.parse(this.data) != '' &&
            JSON.parse(this.data).ip != undefined &&
            JSON.parse(this.data).ip != ''
        "
      >
        <Button
          :type="curIp == item ? 'primary' : 'default'"
          v-for="(item, index) in JSON.parse(this.data).ip"
          :key="index"
          >{{ item }}</Button
        >
      </ButtonGroup>
    </div>
    <div class="recordCom clearfix">
      <div class="fl">
        <ul class="tac">
          <li :class="{ cur: val == 1 }" @click="selectFn(1)">进程树</li>
          <li :class="{ cur: val == 2 }" @click="selectFn(2)">DNS请求记录</li>
          <li :class="{ cur: val == 3 }" @click="selectFn(3)">文件操作记录</li>
          <li :class="{ cur: val == 4 }" @click="selectFn(4)">拦截通知</li>
        </ul>
      </div>
      <div class="fr content">
        <ProcessCom v-if="val == 1" :data="curIp" />
        <DnsCom v-else-if="val == 2" :data="$store.state.log.dnsLog" />
        <FileCom v-else-if="val == 3" :data="$store.state.log.fileLog" />
        <InterceptCom
          v-else-if="val == 4"
          :data="$store.state.log.interceptLog"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ProcessCom from '_c/record/process'
import DnsCom from '_c/record/dns'
import FileCom from '_c/record/file'
import InterceptCom from '_c/record/intercept'
import { getLog } from '@/requests/log'
import { Base64 } from 'js-base64'
export default {
  components: {
    ProcessCom,
    DnsCom,
    FileCom,
    InterceptCom,
  },
  props: ['data', 'barId', 'type'],
  data() {
    return {
      val: 1,
      websock: null,
      isSend: false,
      curIp: '',
      time: 0,
    }
  },
  // watch: {
  //   type() {
  //     console.log(this.type)
  //     console.log(121)
  //     if (this.type) {
  //       this.initWebSocket()
  //     } else {
  //       this.websock.onclose = this.websocketclose
  //     }
  //   },
  //   'this.$store'() {
  //     console.log(12222)
  //     console.log(this.$store.state.log)
  //   },
  // },
  watch: {
    type() {
      console.log(this.type)
      if (this.type) {
        console.log(this.data)
        this.initWebSocket()
        this.curIp = JSON.parse(this.data).ip[0]
      } else {
        this.websock.send(`close=${this.barId}_${this.curIp}`)
      }
    },
    data() {},
  },
  mounted() {},
  destroyed() {
    this.closeFn()
  },
  methods: {
    async getLog() {
      let res = await getLog(10030061, '192.168.98.240')
    },
    closeFn() {
      this.websock.send(`close=${this.barId}_${this.curIp}`)
    },
    selectFn(val) {
      this.val = val
    },
    initWebSocket() {
      if (typeof WebSocket === 'undefined') {
        console.log('你的浏览器不支持WebSocket')
        return false
      }
      let wsUrl = `ws://116.62.42.136:8898/log`
      this.websock = new WebSocket(wsUrl)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketSend(val) {},
    //连接成功
    websocketonopen() {
      console.log('WebSocket连接成功')
      this.$store.dispatch('log/actionResetLog')
      console.log(this.barId)
      console.log(this.curIp)
      this.websock.send(`target=${this.barId}_${this.curIp}`)
    },
    //接收后端返回的数据
    websocketonmessage(e) {
      let dataJson = JSON.parse(e.data)
      if (
        dataJson.logdata.loginfo != '' &&
        dataJson.logdata.loginfo != undefined
      ) {
        this.$store.dispatch(
          'log/actionSetRule',
          this.$MethodFn.Base64ToString(dataJson.logdata.loginfo)
        )
      }
      //console.log(dataJson)
      // 在这里使用后端返回的数据，对数据进行处理渲染
    },
    //连接建立失败重连
    websocketonerror(e) {
      console.log(`连接失败的信息：`, e)
      if (this.time < 3) {
        this.time++
        this.initWebSocket() // 连接失败后尝试重新连接
      }
    },
    websocketclose(e) {
      console.log(222222)
      console.log('关闭链接', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.recordCom {
  padding-top: 20px;
  ul {
    li {
      line-height: 30px;
      width: 120px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      &.cur {
        background: #00cafb;
        color: #fff;
      }
    }
  }
  .content {
    width: calc(100% - 120px);
    border: 1px solid #eee;
    padding: 0 10px 20px;
  }
}
.btnCon {
  margin-top: 20px;
}
</style>
<style></style>
